export default "__VITE_ASSET__KaWR5uQs__"